import invalid from 'assets/icons/invalid.svg';
import tickIcon from 'assets/icons/tick.svg';
import React, { useContext } from 'react';
import { LocaleContext } from 'shared';
import { CertificateDetails } from 'store/api/types';

import { CertificateItemRow, CertificateItemValue, CertificateValidIcon } from './CertificateItem.styles';

const EMPTY_VALUE = 'no data';

export const CertificateItem = (certificateDetails: CertificateDetails) => {
  const localeContext = useContext(LocaleContext);
  const formatDate = (inputDate: string) => {
    const options = {
      day: 'numeric',
      hour: 'numeric',
      hour12: false,
      minute: 'numeric',
      month: 'numeric',
      year: 'numeric',
    };

    return new Date(inputDate).toLocaleDateString(localeContext.locale, options);
  };

  const isValidCertificate = (validTo: string) => {
    const validToDate = new Date(validTo);

    return Date.now() < validToDate.getTime();
  };

  const showDateTimeValue = (input: string, fieldClasses: string) => {
    const dateValue = input ? formatDate(input) : EMPTY_VALUE;

    return showValue(dateValue, fieldClasses);
  };

  const showValue = (input: string, fieldClasses: string) => {
    const fieldClassesValue = input && input !== EMPTY_VALUE ? fieldClasses : `${fieldClasses} no-data-value`;

    return (
      <CertificateItemValue className={`${fieldClassesValue}`}>{input ? input : EMPTY_VALUE}</CertificateItemValue>
    );
  };

  const showIconValue = (input: string) => {
    const isValid = isValidCertificate(certificateDetails.validTo);

    return (
      <CertificateValidIcon className="icon show-on-mobile" isLastColumn={true}>
        <img
          src={isValid ? tickIcon : invalid}
          alt={localeContext.formatMessage({ id: `INTEGRATION-DATA.${isValid ? 'VALID' : 'INVALID'}` })}
        />
      </CertificateValidIcon>
    );
  };

  return (
    <CertificateItemRow className="certificates-group__table-row">
      {showValue(certificateDetails.filename, 'file-name hide-on-mobile')}
      {showDateTimeValue(certificateDetails.uploadDate, 'date-time upload-date hide-on-mobile')}
      {showValue(certificateDetails.fingerprint, 'fingerprint show-on-mobile')}
      {showDateTimeValue(certificateDetails.validFrom, 'date-time valid-from hide-on-mobile')}
      {showDateTimeValue(certificateDetails.validTo, 'date-time valid-to show-on-mobile')}
      {certificateDetails.validTo
        ? showIconValue(certificateDetails.validTo)
        : showValue(EMPTY_VALUE, 'icon show-on-mobile')}
    </CertificateItemRow>
  );
};
